import { Popover, PopoverContent, PopoverTrigger, Pressable, WorkStateIcon, cn } from '@orgus/ui';
import { Link } from 'react-router';
import type { WorkBudgetView } from '@orgus/protocol';
import { CPU_WAITING_EXPLANATION, formatHoldersSummary, formatWaitingForCpuLabel } from './cpuWaiting.ts';

export interface WaitingForCpuBadgeProps {
  placeInLine: number;
  estimateMinutes?: number;
  work?: WorkBudgetView | null;
  className?: string;
  showAddMachine?: boolean;
}

export function WaitingForCpuBadge({ placeInLine, estimateMinutes, work = null, className, showAddMachine = true }: WaitingForCpuBadgeProps) {
  const label = formatWaitingForCpuLabel(placeInLine, estimateMinutes);
  const summary = formatHoldersSummary(work);

  return (
    <Popover>
      <PopoverTrigger asChild>
        <Pressable className={cn('inline-flex w-auto items-center gap-1 rounded-control px-1 text-caption font-medium text-fg-subtle hover:bg-hover', className)} title={label}>
          <WorkStateIcon state="waiting-for-cpu" />
          <span className="truncate">{label}</span>
        </Pressable>
      </PopoverTrigger>
      <PopoverContent align="start" className="w-80 p-3 flex flex-col gap-2 text-ui">
        <div className="flex items-center gap-2">
          <WorkStateIcon state="waiting-for-cpu" />
          <span className="font-semibold text-fg">Waiting for CPU</span>
        </div>
        <p className="text-caption font-medium text-fg-muted">{label}</p>
        <div className="rounded-control bg-raised p-2 text-caption font-mono text-fg-subtle">
          {summary}
        </div>
        <p className="text-caption text-fg-subtle leading-relaxed">
          {CPU_WAITING_EXPLANATION}
        </p>
        <div className="mt-1 flex items-center justify-between gap-2 text-caption">
          <Link to="/capacity" className="font-medium text-accent-text hover:underline">
            Open Capacity
          </Link>
          {showAddMachine && (
            <Link to="/machines" className="text-fg-muted hover:underline">
              Add a machine
            </Link>
          )}
        </div>
      </PopoverContent>
    </Popover>
  );
}
